// Configuration for API endpoints
const config = {
  // API base URL - use environment variable or fallback to localhost
  // In production, use the direct API URL since Vercel proxy is not working
  API_BASE_URL: process.env.NODE_ENV === 'production' ? 'https://api.weenable.ai' : (process.env.REACT_APP_API_URL || 'http://localhost:5001'),
  
  // Individual endpoints
  ENDPOINTS: {
    GENERATE: '/generate',
    GENERATE_FAQ: '/generate_faq',
    GENERATE_BATTLECARD: '/generate_battlecard',
    GENERATE_ARCHITECTURE: '/generate_architecture',
    GENERATE_SCORM: '/generate_scorm',
    INITIALIZE_SALES_CALL: '/initialize_sales_call',
    SALES_CALL_MESSAGE: '/sales_call_message',
    DOWNLOAD_TRANSCRIPT: '/download_transcript',
    DOWNLOAD: '/download',
    HEALTH: '/health',
    VERIFY_APP_PASSWORD: '/verify-app-password',
    REGISTER: '/register',
    LOGIN: '/login',
    LOGOUT: '/logout',
    USER_PROFILE: '/user/profile',
    USER_CREDITS: '/user/credits',
    DELETE_ACCOUNT: '/user/delete-account',
    VERIFY_EMAIL: '/verify-email',
    FORGOT_PASSWORD: '/forgot-password',
    RESET_PASSWORD: '/reset-password',
    RESEND_VERIFICATION: '/resend-verification'
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint) => {
  const url = `${config.API_BASE_URL}${endpoint}`;
  console.log('🔧 getApiUrl:', { endpoint, API_BASE_URL: config.API_BASE_URL, finalUrl: url });
  return url;
};

export default config; 